
import { gameState } from "appworks/model/game-state";
import { Services } from "appworks/services/services";
import { State } from "appworks/state-machine/states/state";
import { UIFlag, uiFlags } from "appworks/ui/flags/ui-flags";
import { GambleCollectCommand } from "slotworks/commands/comms/gamble-collect-command";
import { SpinRecord } from "slotworks/model/gameplay/records/spin-record";

export class Autoplay extends State {
    protected collecting: boolean = false;

    public onEnter() {
        uiFlags.set(UIFlag.IDLE, false);
        uiFlags.set(UIFlag.GAME_IN_PROGRESS, true);
        Services.autoplay.spin();
        this.collecting = false;

        const record: SpinRecord = gameState.getCurrentGame().getCurrentRecord() as SpinRecord;

        if (record.gamble) {
            this.collecting = true;
            GambleCollectCommand().then(() => {
                this.complete();
            });
        } else {
            this.complete();
        }
    }

    public onSkip() {
        if (!this.collecting) {
            const record: SpinRecord = gameState.getCurrentGame().getCurrentRecord() as SpinRecord;

            if (record.gamble) {
                this.collecting = true;
                GambleCollectCommand().then(() => {
                    this.skip();
                });
            } else {
                this.skip();
            }
        }
    }
}
